import React, { useEffect, useState, useRef } from 'react';
import { uploadImageToS3 } from 'src/components/utilities/utils';
import { successMsg } from 'src/components/utilities/utils';

interface IProps {
  videoId: string;
  setUploadChapterUrl: (value: string) => void;
  uploadChapterUrl: string;
}

const UploadChapterModal: React.FC<IProps> = ({
  videoId,
  setUploadChapterUrl,
  uploadChapterUrl
}) => {
  const [selectedFile, setSelectedFile] = useState<any>('');
  const cancelButtonRef = useRef<HTMLButtonElement>(null);
  const handleVideoChapterUpload = async () => {
    if (selectedFile) {
      uploadImageToS3(
        selectedFile[0],
        `v2/video/chapters?videoId=${videoId}&isVideoChapters=true&`,
        setUploadChapterUrl,
        'chapterUrl'
      );
    }
  };
  useEffect(() => {
    if (uploadChapterUrl) {
      if (cancelButtonRef.current) {
        cancelButtonRef.current.click();
      }
    }
  }, [uploadChapterUrl]);

  return (
    <div>
      <div
        className="modal fade"
        id="UploadChapterModal"
        aria-labelledby="UploadCaptionsModalLabel"
        aria-hidden="true">
        <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
          <div className="modal-content">
            <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
              <h5
                className="text-xl font-semibold leading-normal text-center w-full"
                id="UploadCaptionsModalLabel">
                Upload Webvtt Chapters
              </h5>
              <button
                ref={cancelButtonRef}
                type="button"
                className="dismiss-btn"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body relative py-4 px-10">
              <form>
                <label className="font-semibold">Select Chapters file:</label>
                <div className={`form-group my-5`}>
                  <div className="input-style p-0 speaker-browse-file flex items-center">
                    <input
                      id="uploadFile"
                      className="pl-2"
                      placeholder={`${selectedFile && selectedFile[0].name}`}
                    />
                    <div className="fileUpload btn btn-primary mt-0 ml-auto mr-0 px-1 w-28">
                      <span>Select File</span>
                      <input
                        id="uploadBtn"
                        type="file"
                        className="upload"
                        onChange={(e) => setSelectedFile(e.target.files)}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center p-4 pb-6 pt-0 rounded-b-md">
              <button
                onClick={handleVideoChapterUpload}
                type="submit"
                className="px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-0">
                Save Changes
              </button>
              <button
                type="button"
                className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadChapterModal;
